import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { ContactHelper } from 'src/app/helpers/contact-helper';
import ProjectContact from 'src/app/model/company/projectContact';
import Contact from 'src/app/model/Contact/contact';
import { Project } from 'src/app/model/project/project';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';

export class IPBoardAppointmentHelper {
  private constructor() {}

  static getCompanyIds(project: Project): number[] {
    if (
      project == null ||
      !CollectionHelper.isPopulated(project.projectContacts)
    ) {
      return null;
    }

    const companyIds = new Set<number>();
    project.projectContacts.forEach(pc => {
      if (pc.company != null && pc.company.id != null) {
        companyIds.add(pc.company.id);
      }
    });
    return [...companyIds];
  }

  static getCompanyIdsFromProjectContacts(
    projectContacts: ProjectContact[]
  ): number[] {
    if (!CollectionHelper.isPopulated(projectContacts)) {
      return null;
    }

    const companyIds = new Set<number>();
    projectContacts.forEach(pc => {
      if (pc.company != null && pc.company.id != null) {
        companyIds.add(pc.company.id);
      }
    });
    return [...companyIds];
  }

  static processContactChoices(
    choices: Contact[],
    projectPlacement: ProjectPlacement,
    formatPhoneNumber: FormatPhoneNumber
  ): void {
    choices = choices == null ? [] : choices;
    choices.forEach(c => ContactHelper.setFormDisplays(c, formatPhoneNumber));
    if (
      projectPlacement != null &&
      projectPlacement.appointmentContact != null &&
      !choices.some(c => c.id === projectPlacement.appointmentContact.id)
    ) {
      choices.push(projectPlacement.appointmentContact);
    }
  }
}
